
import ViewBox from 'vux/src/components/view-box/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'
import Toast from 'vux/src/components/toast/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import {
wxConfigAjax,
system
} from './api';
import MFooter from './components/Footer/Footer'
import Login from './components/Login/Login'
import Download from './components/DownLoad/DownLoad'
import AnimateAddShop from './components/Classify/AnimateAddShop.vue';
export default {
name: 'app',
components: {
ViewBox,
Loading,
Login,
Toast,
Download,
MFooter,
AnimateAddShop,
XHeader
},
computed: {
isTab() {
return this.$store.state.isTab;
},
isLoading() {
return this.$store.state.isLoading;
},
toast() {
return this.$store.state.toast;
},
bodyPaddBtm() {
return this.$store.state.bodyPaddBtm;
},
isLogin() {
return this.$store.state.isLogin;
},
shopInfo() {
return this.$store.state.shopInfo;
},
_scrollTop() {
return this.$store.state.scrollTop;
}
},
methods: {
isTabHide(pathName) {
let that = this;
const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : "";
let tabPathName = ['home', 'classify', 'shoppCart', 'userCenter', 'activity'];
let tabIsTrue = tabPathName.indexOf(pathName) == -1 ? 'hideIsTab' : 'showIsTab';
this.$store.commit(tabIsTrue);

if (this.$store.state.isWx && this.shopInfo.shopname) {
wxConfigAjax({
title: this.shopInfo.shopname + '官方商城',
desc: this.shopInfo.shopname + '官方商城',
url: 'home?shop_id=' + this.shopInfo.shop_id,
imgUrl: this.shopInfo.shop_logo
});
};

/*
如果没有缓存登录信息 并且 不是微信端
弹出登录框 隐藏底部tab
*/
if (!userInfo && !this.$store.state.isWx) {
this.$store.commit('hideIsTab');
};


const pathNamePadd = ['classify', 'home', 'userCenter', 'shoppCart', 'detail', 'createOrder', 'shippingAddress', 'takeWineDetail', 'recommend'];
if (pathNamePadd.indexOf(pathName) >= 0) {
this.$store.commit('showBodyPaddBtm');
} else {
this.$store.commit('hideBodyPaddBtm');
};
},
scrollHandler() {
var scrollTop = this.$refs.viewBox.getScrollTop();
this.scrollTop = scrollTop;
if (this._pathName == 'shoppCart') {
this.isBackTop = false;
return;
};
this.isBackTop = scrollTop > 300 ? true : false;
this.$store.commit('updateScrollTop', scrollTop);
if (this.$route.name == 'home') {
this.$store.commit('updateHomeScrollTop', {
top: scrollTop
});
};


},
toBackTop(top = 0) {
if (top == 0) {
let scrollTop = document.querySelector('#vux_view_box_body').scrollTop;
var timer = setInterval(() => {
scrollTop = Math.floor(scrollTop / 10);
document.querySelector('#vux_view_box_body').scrollTop = scrollTop;
if (scrollTop <= 0) {
clearInterval(timer);
};
}, 30);
} else {
document.querySelector('#vux_view_box_body').scrollTop = top;
};
}
},
watch: {
$route(to) {
let pathName = to.name;
this._pathName = pathName;
let that = this;
this.isTabHide(pathName);

if (pathName == 'home') {
setTimeout(function() {
that.toBackTop(that.$store.state.homeScrollTop);
}, 0);
} else {
setTimeout(function() {
that.toBackTop(0);
}, 0);
};
}
},
mounted() {
let pathName = this.$route.name;
let that = this;
this.isTabHide(pathName);

this.box = document.querySelector('#vux_view_box_body');
this.box.addEventListener('scroll', this.scrollHandler, false);

},
data() {
return {
isBackTop: false,
scrollTop: "0",
_pathName: ""
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue